// extracted by mini-css-extract-plugin
export default {"benefits":"Benefits-module__benefits--CJ9oX","benefits__item":"Benefits-module__benefits__item--lZ48H"};